<!-- src/App.vue -->
<template>
  <div id="app" class="app-container">
    <HeaderMenu />
    <main class="content">
      <router-view />
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import HeaderMenu from './views/HeaderMenu.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  components: {
    HeaderMenu,
    FooterComponent
  }
};
</script>

<style>
/* Global styles */
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1;
}
</style>
